
<template>
  <div id="app">
      <!--  Preloader  -->
      <div id="preloader">
          <div id="loading"> </div>
      </div>
      <div class="main">
          <header class="home3">
              <!--  nav  -->
              <nav class="navbar navbar-inverse navbar-default">

                  <div class="navbar-header home2-nav">
                      <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1"> <span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span> </button>
                      <a class="navbar-brand" href="#"><img src="/img/logo_2.png" alt="logo" style="width:251px;height:22px;"></a>
                  </div>
                  <!-- Collect the nav links, forms, and other content for toggling -->
                  <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1" data-hover="dropdown" data-animations="fadeIn fadeInLeft fadeInUp fadeInRight">
                      <ul class="nav navbar-nav">
                          <!-- <li class="dropdown"> <a href="index.html" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-expanded="false"><span>主页</span></a> -->
                          <li> <router-link to="/home"><span>主页</span></router-link></li>

                          <li> <router-link to="/shop"><span>商城</span></router-link> </li>


                          <li> <router-link to="/news"><span>新闻</span></router-link> </li>
                          <li> <router-link to="/about"><span>关于</span></router-link> </li>
<!--                          <li> <a href="#nogo"><span>联系方式</span></a> </li>-->
                      </ul>
                      <!-- <ul class="nav navbar-nav navbar-brand">
              <img src="/img/logo_2.png" alt="logo" style="width:251px;height:22px;">
            </ul> -->
                      <ul class="nav navbar-nav navbar-right">
                          <li>
                              <a href="#" data-toggle="modal" data-target=".popup1"><img src="/images/top-icon1.png" alt="top-icon1"> <span>搜索</span></a>
                          </li>
                          <li class="dropdown">
                              <a href="#" class="dropbtn"> <img src="/images/top-icon3.png" alt="top-ico3"> <span>购物车 (0)</span> </a>
                              <!-- <div class="dropdown-content">
                  <div class="cart-content">
                    <div class="col-sm-4 col-md-4"><img src="/images/Products/13.jpg" alt="13"></div>
                    <div class="col-sm-8 col-md-8">
                      <div class="pro-text"> <a href="#">Pellentesque Habitant</a>
                        <div class="close">x</div> <strong>$160.00</strong> </div>
                    </div>
                  </div>
                  <div class="cart-content">
                    <div class="col-sm-4 col-md-4"><img src="/images/Products/11.jpg" alt="13"></div>
                    <div class="col-sm-8 col-md-8">
                      <div class="pro-text"> <a href="#">Pellentesque Habitant</a>
                        <div class="close">x</div> <strong>$160.00</strong> </div>
                    </div>
                  </div>
                  <div class="total">
                    <div class="col-sm-6 col-md-6 text-left"> <span>Shipping :</span>
                      <br> <strong>Total :</strong> </div>
                    <div class="col-sm-6 col-md-6 text-right"> <strong>$0.00</strong>
                      <br> <strong>$160.00</strong> </div>
                  </div>
                  <div class="col-lg-12"><a href="shopping-cart.html" class="cart-btn">VIEW CART </a> <a href="checkout.html" class="cart-btn">CHECKOUT</a></div> </div> -->
                          </li>
                          <li>
                              <!-- <a href="#" data-toggle="modal" data-target=".menu-popup"><img src="/images/top-icon2.png" alt="top-icon2"></a> -->
                          </li>
                      </ul>
                      <!-- /.navbar-collapse -->
                  </div>
              </nav>
              <!--  /nav  -->
              <!-- search-popup -->
              <div class="modal fade bs-example-modal-lg search-bg popup1" tabindex="-1" role="dialog">
                  <div class="modal-dialog modal-lg" role="document">
                      <div class="modal-content search-popup">
                          <div class="text-center">
                              <a href="#" class="close2" data-dismiss="modal" aria-label="Close">× close</a>
                          </div>
                          <div class="search-outer">
                              <div class="col-md-11"><input type="text" placeholder="Search for products..." /></div>
                              <div class="col-md-1 text-right"><a href="#"><i class="fa fa-search" aria-hidden="true"></i></a></div>
                          </div>
                      </div>
                  </div>
              </div>
              <!-- /search-popup -->
              <!--  .menu  -->


          </header>


      </div>
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {
  }
}
</script>

<style>
body {
  margin: 0px;
  padding: 0px;
  font-family:'Microsoft YaHei','微软雅黑','PingFang SC','苹方',Serif;
  font-size: 14px;
  -webkit-font-smoothing: antialiased;
}
a{
    color: #262626;
}
.router-link-exact-active{
    font-weight: bold;
}

#app {
  margin:0px;
  padding:0px;
}

</style>
